module.exports = __webpack_public_path__ + "media/newstyle/images/amex-4014269cb0d993f1424b36a53d331404.svg";